/* top-nav.tsx generated by @compiled/babel-plugin v0.36.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./top-nav.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import AppSwitcherIcon from '@atlaskit/icon/core/app-switcher';
import NotificationIcon from '@atlaskit/icon/core/notification';
import PersonAvatarIcon from '@atlaskit/icon/core/person-avatar';
import QuestionCircleIcon from '@atlaskit/icon/core/question-circle';
import SearchIcon from '@atlaskit/icon/core/search';
import SettingsIcon from '@atlaskit/icon/core/settings';
import SidebarCollapseIcon from '@atlaskit/icon/core/sidebar-collapse';
import { ConfluenceIcon, ConfluenceLogo, JiraIcon, JiraLogo, JiraProductDiscoveryIcon, JiraProductDiscoveryLogo, JiraServiceManagementIcon, JiraServiceManagementLogo, RovoIcon } from '@atlaskit/logo';
import { Box, Inline, media } from '@atlaskit/primitives/compiled';
import { useMatchMedia } from '../../common/ui';
import { Products } from '../../types';
var styles = {
  wrapper: "_18zrv47k _n7zl7r9e _4t3ickbl _1bsb1osq",
  search: "_195goahv _1bsb1osq",
  searchBar: "_2rkoiti9 _19it7r9e _4t3izwfg _1bsb1osq _p12fcv93 _1ul91178",
  createButton: "_2rkoiti9 _4t3izwfg _1bsbys9h _bfhk4v9p",
  createButtonText: "_2rkoiti9 _4t3ii2wt _1bsb1ady",
  chatButton: "_2rkoiti9 _19it7r9e _4t3izwfg _1bsbcae7",
  chatButtonText: "_2rkoiti9 _4t3ii2wt _1bsbzwfg"
};
var ProductLogos = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Products.JIRA, JiraLogo), Products.CONFLUENCE, ConfluenceLogo), Products.JIRA_PRODUCT_DISCOVERY, JiraProductDiscoveryLogo), Products.JIRA_SERVICE_MANAGEMENT, JiraServiceManagementLogo);
var ProductIcons = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Products.JIRA, JiraIcon), Products.CONFLUENCE, ConfluenceIcon), Products.JIRA_PRODUCT_DISCOVERY, JiraProductDiscoveryIcon), Products.JIRA_SERVICE_MANAGEMENT, JiraServiceManagementIcon);
export var TopNav = function TopNav(_ref) {
  var product = _ref.product;
  var isAboveMediumScreen = useMatchMedia(media.above.md);
  var Logo = ProductLogos[product];
  var Icon = ProductIcons[product];
  return /*#__PURE__*/React.createElement(Inline, {
    xcss: styles.wrapper,
    spread: "space-between",
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    space: "space.200"
  }, /*#__PURE__*/React.createElement(SidebarCollapseIcon, {
    label: "Sidebar collapse",
    color: "var(--ds-icon-subtle, #626F86)"
  }), /*#__PURE__*/React.createElement(AppSwitcherIcon, {
    label: "App switcher",
    color: "var(--ds-icon-subtle, #626F86)"
  }), isAboveMediumScreen ? /*#__PURE__*/React.createElement(Logo, {
    appearance: "brand",
    size: "small"
  }) : /*#__PURE__*/React.createElement(Icon, {
    appearance: "brand",
    size: "small"
  })), /*#__PURE__*/React.createElement(Inline, {
    xcss: styles.search,
    alignInline: "center",
    space: "space.100"
  }, /*#__PURE__*/React.createElement(Inline, {
    xcss: styles.searchBar,
    alignBlock: "center"
  }, /*#__PURE__*/React.createElement(SearchIcon, {
    label: "Search",
    color: "var(--ds-icon-subtle, #626F86)",
    spacing: "spacious"
  })), /*#__PURE__*/React.createElement(Inline, {
    xcss: styles.createButton,
    alignBlock: "center",
    alignInline: "center"
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: styles.createButtonText,
    backgroundColor: "color.background.accent.blue.subtler.hovered"
  }))), /*#__PURE__*/React.createElement(Inline, {
    alignBlock: "center",
    space: "space.200"
  }, /*#__PURE__*/React.createElement(Inline, {
    xcss: styles.chatButton,
    alignBlock: "center",
    alignInline: "center",
    space: "space.050"
  }, /*#__PURE__*/React.createElement(RovoIcon, {
    size: "xxsmall",
    appearance: "neutral"
  }), /*#__PURE__*/React.createElement(Box, {
    xcss: styles.chatButtonText,
    backgroundColor: "color.background.accent.gray.subtlest.hovered"
  })), /*#__PURE__*/React.createElement(NotificationIcon, {
    label: "Notifications",
    color: "var(--ds-icon-subtle, #626F86)"
  }), /*#__PURE__*/React.createElement(QuestionCircleIcon, {
    label: "Help",
    color: "var(--ds-icon-subtle, #626F86)"
  }), /*#__PURE__*/React.createElement(SettingsIcon, {
    label: "Settings",
    color: "var(--ds-icon-subtle, #626F86)"
  }), /*#__PURE__*/React.createElement(PersonAvatarIcon, {
    label: "User",
    color: "var(--ds-icon-subtle, #626F86)"
  })));
};